import styled from 'styled-components';

export const ColorTitle = styled.div`
    margin-bottom: 17px;
    font-weight: 400;
    font-size: 24px;
    line-height: 32px;
    color: #212121;
`